"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/*globals Kobo,ko*/
Kobo.Popup = /*#__PURE__*/function () {
  function Popup(config) {
    _classCallCheck(this, Popup);

    this.config = config;
    this.$popup = null;
    this.vm = null; // we pass our hide method as a callback, so want to let it keep its `this` reference

    this.hide = this.hide.bind(this);
  }

  _createClass(Popup, [{
    key: "destroy",
    value: function destroy() {
      if (this.$popup) {
        this.$popup.remove();
        this.$popup = null;
      }
    }
  }, {
    key: "hide",
    value: function hide() {
      if (this.vm) {
        this.vm.isOpen(false);
      }

      if (this.config.onClose) {
        this.config.onClose();
      }
    }
  }, {
    key: "show",
    value: function show() {
      if (this.$popup) return;
      var $template = Kobo.$(Kobo.$("#popup-type-selector-template").html());

      if ($template.length) {
        var $parentElement;
        this.vm = new Kobo.Popup.VM({
          layoutTemplate: this.config.layout === "dialog" ? "dialog-template" : "popup-template",
          content: this.config.content,
          ariaLive: this.config.ariaLive,
          role: this.config.role,
          position: this.config.position,
          style: this.config.style,
          width: this.config.width,
          title: this.config.title,
          buttons: this.config.buttons,
          focusOnOpen: this.config.focusOnOpen,
          closeOnClick: this.config.closeOnClick
        });
        this.vm.closeEvent.subscribe(this.hide);
        this.$popup = $template.clone();

        if (this.config.parent) {
          $parentElement = Kobo.$(this.config.parent);
        } else {
          $parentElement = Kobo.$body;
        }

        $parentElement.addClass('contains-popup');
        $parentElement.append(this.$popup);
        ko.applyBindings(this.vm, this.$popup[0]);
      }

      if (this.vm) {
        this.vm.isOpen(true);
      }
    }
  }]);

  return Popup;
}();

Kobo.Popup.VM = /*#__PURE__*/function () {
  function PopupVM(config) {
    _classCallCheck(this, PopupVM);

    this.layoutTemplate = ko.observable(config.layoutTemplate || 'popup-template');
    this.content = ko.observable(config.content);
    this.isOpen = ko.observable(false);
    this.ariaLive = ko.observable(config.ariaLive || 'polite');
    this.role = ko.observable(config.role || 'dialog');
    var position = config.position || {};
    this.css = {
      show: this.isOpen,
      closeable: this.closeOnClick,
      'right-aligned': position.rightAligned
    };
    var style = config.style || {};
    style.top = position.top;
    style.width = config.width;
    this.style = ko.observable(style); // Dialog specific options

    this.title = ko.observable(config.title); // TODO: Doesn't seem to be in used - can be removed?

    this.buttons = config.buttons || []; // Popup specific options

    this.focusOnOpen = ko.observable(config.focusOnOpen || false);
    this.closeOnClick = ko.observable(config.closeOnClick || false);
    this.closeEvent = new ko.subscribable();
  }

  _createClass(PopupVM, [{
    key: "close",
    value: function close() {
      this.closeEvent.notifySubscribers();
    }
  }]);

  return PopupVM;
}();